const popUpReducer = (variant) => (state = null, action) => {
  switch (action.type) {
    case `${variant}_POPUP_SET`: return action.payload;
    case `${variant}_POPUP_CLOSE`: return null;
    default: return state;
  }
};

export default popUpReducer;
